import { authService } from './authService';

export const statistiquesService = {
  async getStats(page = 'company') {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/statistiques?page=${page}`, {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${authService.getToken()}`
        }
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des statistiques');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('❌ Erreur getStats:', error);
      throw error;
    }
  }
}; 